import { Component, Input, Output, OnInit, OnChanges, EventEmitter, SimpleChanges } from '@angular/core';
import { CampoAggiuntivo, CampoUtility } from "../models/campo-aggiuntivo";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewsComponent } from 'src/app/task/news/news.component';
import { isBetweenString } from 'src/environments/Utility/DateUtility';


@Component({
  selector: 'app-dynamic-col-table',
  templateUrl: './DynamicColTable.component.html',
  styleUrls: ['./DynamicColTable.component.scss']
})
export class DynamicColTable implements OnInit {


  @Input() hasSave: boolean = false;
  @Input() hasNote: boolean = false;
  @Input() editable: boolean = true;
  @Input() notePlaceholder: string = "";
  @Output() onSaveClick = new EventEmitter<any>();

  @Input() rows
  @Output() rowsChange = new EventEmitter<any[]>();
  /*= [
      {id: 286, nominativo: "Anna Romano"},
  {id: 293, nominativo: "Fabio Fabbri"}
  ]*/
  @Input() columns
  @Output() columnsChange = new EventEmitter<any[]>();
  @Input() CampiColonne: { nome: string, param: string | number }[];

  @Output() Refresh = new EventEmitter();
  constructor(
    private modalService: NgbModal,
    private campoUtility: CampoUtility
  ) { }

  ngOnInit() {

  }

  Save() {
    this.onSaveClick?.emit({ rows: this.rows, columns: this.columns });
  }
  Media(cliente, columns) {
    let tot = 0;
    let cont = 0;
    columns.forEach(column => {
      if (column.esiti) {
        column.esiti.forEach(attivita => {
          if (attivita.cliente == cliente.id) {
            tot += parseInt(attivita.esiti[0].toString()) + parseInt(attivita.esiti[1].toString()) + parseInt(attivita.esiti[2].toString());
            if (!this.IsAssente(cliente, column))
            cont += 3;
          }
        });
      }
    });
    return tot / cont;
  }
  PercentPres(cliente, columns) {
  let tot = 0;
  let cont = 0;
  columns.forEach(column => {
    if (column.esiti) {
      column.esiti.forEach(attivita => {
        if (attivita.cliente == cliente.id) {
          tot++;
          if(!this.IsAssenteLAb(cliente, column))
            cont ++;
        }
      });
    }
  });
  return cont / tot * 100;
  }

  IsAssenteLAb(cliente, attivita) {
    return !attivita?.clienti?.some(x => x == cliente.id);
   // return cliente?.assenze?.some(x => isBetweenString(x.data_inizio_prevista, attivita.data_inizio_prevista, attivita.data_inizio_prevista));
  }

  IsAssente(cliente, attivita) {
   // return !attivita?.clienti?.some(x => x == cliente.id);
     return cliente?.assenze?.some(x => isBetweenString(x.data_inizio_prevista, attivita.data_inizio_prevista, attivita.data_inizio_prevista));
  }

  attivitatooltip(attivita) {
    return `${attivita.nome ?? ''} \n- ${attivita.managerObject?.fullName ?? ''} \n- ${attivita.descrizione ?? ''} \n ${attivita.note ?? ''}`;
  }
  OpenTask(task, cliente?) {
    var dynamicFields = this.campoUtility.getDynamicTaskSctructure(task?.type, task?.tipo);
    let Newsmodal = this.modalService.open(NewsComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<NewsComponent>Newsmodal.componentInstance).DynamicFields = dynamicFields;
    (<NewsComponent>Newsmodal.componentInstance).IsModal = true;
    (<NewsComponent>Newsmodal.componentInstance).Item = Object.assign({cliente : cliente?.id}, task);
    (<NewsComponent>Newsmodal.componentInstance).updated.subscribe(data => {
      this.Refresh.emit();
    });
  }
  protected readonly CampoAggiuntivo = CampoAggiuntivo;
}




